import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { InteractionService } from './services/interaction.service';

export function provideOutlookInteractionLogDataAccess(): EnvironmentProviders {
  return makeEnvironmentProviders([InteractionService]);
}
